import React from 'react'
import DistributorContainer from './DistributorContainer'

const Distributor = props => (
  <DistributorContainer {...props} data-test="component-stock-vehicle-detail-distributor" />
)
export default Distributor
